import React, { Component } from "react";
import { connect } from "react-redux";
import { finishApplication, cancelApplication } from "../../actions";
import PropTypes from "prop-types";
import Frame from "../Frame";
import { closeModal } from "containers/MultistepModal/actions";

class OwnleaseContract extends Component {

  receiveMessage = (event) => {
    const { finishApplication } = this.props
    switch (event.data) {
      case "paypossible_order_success":
        finishApplication();
        break;
    }
  }

  render() {
    const { contractUrl, hidden } = this.props
    return (
      <Frame
        hidden={hidden}
        contractUrl={contractUrl}
        onReceiveMessage={this.receiveMessage}
      />
    )
  }
}

OwnleaseContract.propTypes = {
  contractUrl: PropTypes.string
};

OwnleaseContract.defaultProps = {
  contractUrl: ""
};

const mapDistpatchToProps = dispatch => {
  return {
    finishApplication: values => dispatch(finishApplication(values)),
    cancelApplication: values => dispatch(cancelApplication(values)),
    closeModal: () => dispatch(closeModal())
  };
};

OwnleaseContract = connect(null, mapDistpatchToProps)(OwnleaseContract);

export default OwnleaseContract;

